import { FilterContracts } from './interfaces'

export const camposConsultaBA = new Set([
    'baseConsulta',
    'ufContrato',
    'chassi',
    'cnpjAgenteFinanceiro',
    'cpfCnpjDevedor',
    'numeroContrato'
])

export const isConsultaBA = (baseConsulta: string, ufContrato: string) =>
    baseConsulta === 'DETRAN' && ufContrato === 'BA'

// O resolver também recebe valores de campos ocultos restaurados do cache.
export const limparFiltrosConsultaBA = (filtros: FilterContracts) => {
    if (!filtros || !isConsultaBA(filtros.baseConsulta, filtros.ufContrato)) {
        return filtros
    }

    return Object.fromEntries(
        Object.entries(filtros).map(([campo, valor]) => [
            campo,
            camposConsultaBA.has(campo) ? valor : ''
        ])
    ) as FilterContracts
}
